/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Vuelidate from 'vuelidate'
import VueLazyload from 'vue-lazyload'
import routes from './routes'

Vue.use(VueLazyload)
Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'page',
})


const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      setTimeout(() => {
        const element = document.getElementById(to.hash.replace(/#/, ''))
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 500)
    }
    if (from.path === to.path && !to.hash && from.name === 'getYourPass') {
      return { x: 0, y: 0 }
    }
    if (from.path === to.path) {
      return {}
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

// function isQueryEshop(route) {
//   return !!route.query.eshopId
// }

router.beforeEach((to, from, next) => {
  let eshopId
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    if (localStorage.eshopId) {
      eshopId = localStorage.eshopId
    }
    to.query.eshopId = eshopId
    next({ path: to.path, query: to.query })
  } else {
    next()
  }
})

export default router
